import { render } from "./MyPanel.vue?vue&type=template&id=61cab24e"
import script from "./MyPanel.vue?vue&type=script&lang=js"
export * from "./MyPanel.vue?vue&type=script&lang=js"

import "./MyPanel.vue?vue&type=style&index=0&id=61cab24e&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__